import React from 'react'
import Navbar from "../components/navbar";
import genInfoHeader from "../assect/images/bg/dl_curvedimgs_info.png";
import AvailableProperties from "../components/availableproperties";
import Footer from "../components/footer";

const generalInfoObj = {
    statement: "At Dimora Living, we manage our properties with pride and provide full-service experience for our residents, putting your comfort and needs above all else.",
    items: [{
        title: "Units That Fit Your Needs",
        subtitle: "",
        detail: "Some of our properties come fully furnished, stocked with kitchenware, and move-in ready. Others are unfurnished and are ready for your personal setup."
    }, {
        title: "Pet-Friendly Living",
        subtitle: "",
        detail: "At Dimora Living, we know they’re part of the family, and we’re proud to offer pet-friendly experience."
    }]
}

export default function GeneralInformation() {
    const ListGeneralInfoItems = (arrInfo) => {

        return (
            <ul style={{ listStyle: "none", paddingLeft: 0 }} className="mt-lg-3 mb-0">
                {
                    arrInfo.arrInfo.map((item, index) => (
                        <li key={index} style={{ marginInlineStart: "0" }}>
                            <p style={{ fontWeight: "bold", fontSize: "13pt" }}>{item.title}</p>
                            {item.subtitle.trim().length > 0 ? <span style={{ fontWeight: "bold", fontSize: "13pt" }}>{item.subtitle}</span> : null}
                            <p style={{ fontSize: "13pt" }}>{item.detail}</p>
                        </li>
                    ))
                }
            </ul>
        )
    }

    return (
        <div style={{ backgroundColor: "#f0eadd" }}>
            <Navbar navClass="defaultscroll sticky" logolight={true} menuClass="navigation-menu nav-right" />
            <div className="top-half top-half d-table w-100 pt-5">
                <section className="bg-half-116" style={{ backgroundImage: `url(${genInfoHeader})` }}>
                </section>
            </div>

            <section className="section-50 pb-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <p className="mb-md-5 mb-sm-4 sub_heading">General Information</p>
                        </div>
                        <div className="row  justify-content-center">

                            <div className="col-xxl-6 col-lg-8 col-12">
                                <div className="section-title ms-lg-12 align-content-lg-end">
                                    <h6 className="mb-0" style={{ fontSize: "13pt", color: "#093b38" }}>{generalInfoObj.statement}</h6>
                                    <ListGeneralInfoItems arrInfo={generalInfoObj.items} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative avaliable_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <AvailableProperties />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}